import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import messages from '../documentMessages';

const AuthorizationListDetail = ({ document }) => {
  if (!document.recognitionMeta) return null;
  const authorizationListDocument =
    typeof document.recognitionMeta === 'string'
      ? JSON.parse(document.recognitionMeta)
      : document.recognitionMeta;

  return (
    <div className="margin10B">
      <div className="row">
        <div className="col-md-2">
          <FormattedMessage {...messages.AmountOfAuthorizations} />
        </div>
        <label>{authorizationListDocument.numberOfAuthorizations}</label>
      </div>
      <div className="row">
        <div className="col-md-2">
          <FormattedMessage {...messages.AmountOfRelations} />
        </div>
        <label>{authorizationListDocument.numberOfRelations}</label>
      </div>
    </div>
  );
};

AuthorizationListDetail.propTypes = {
  document: PropTypes.shape({}).isRequired,
};

export default AuthorizationListDetail;
